import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router/composables';
import { FadeTransition } from '@/modules/common/components/FadeTransition';
import HomeHeroActions from './components/HomeHeroActions.vue';
import HomeHeroSummary from './components/HomeHeroSummary.vue';
import { trackBalanceAccountErrorLoad } from './track-events';
import { trackTransactionsPageNavigation } from '@/modules/transaction/helpers/transactions-events';
import { WarrenModules } from '@/types/navigation';
import * as trackEvents from './track-events';
import {
  getHeroBalanceAndButtons,
  HomeBalanceHero
} from '../../services/balances';
import { SectionError } from '@/modules/common/components/SectionError';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeHero',
  props: {
    isOverdue: { type: Boolean }
  },
  emits: ["on-error"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'on-error', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isOverdue: boolean;
};





const router = useRouter();

const isLoading = ref(true);
const hasError = ref(false);
const heroButtons = ref<HomeBalanceHero | null>(null);

onMounted(() => {
  fetchHeroButtons();
});

async function fetchHeroButtons() {
  hasError.value = false;

  try {
    heroButtons.value = await getHeroBalanceAndButtons();
  } catch {
    hasError.value = true;
    emit('on-error', hasError.value);
    trackBalanceAccountErrorLoad();
  } finally {
    isLoading.value = false;
  }
}

function getValueWithDefault(value?: string | null, defaultValue = 'R$ 0,00') {
  return value || defaultValue;
}

const balance = computed(() =>
  getValueWithDefault(heroButtons.value?.accountBalance, '')
);

function redirectToTransactionsPage() {
  router.push({ name: 'transactions' });

  trackTransactionsPageNavigation(WarrenModules.Home);
  trackEvents.trackViewMoreTransactionsEvent();
}

return { __sfc: true,props, emit, router, isLoading, hasError, heroButtons, fetchHeroButtons, getValueWithDefault, balance, redirectToTransactionsPage, FadeTransition, HomeHeroActions, HomeHeroSummary, SectionError }
}

})